import React from 'react';
import { connect } from 'react-redux'
import AccordionTitle from './accordionTitle'
import AccordionTitleRskn from './../change/buildProduct/accordionTitleRskn';
import ProductContainer from './productContainer'
import { Service } from './../../constants/actionType';
import ReactHtmlParser from 'react-html-parser';
import { accordionFocusAnimate, focusAnimation, focusAnimationPerks, setAPEnabled, spanishTab } from './../../action/buildProduct';
import { InHomeUtils } from './../../util/inhomeUtils';
import { Tabs, Tab } from '@vds/tabs';
import {Toggle} from '@vds/toggles';
import { TrailingTooltip } from '@vds/tooltips';
import { updateSCTags } from './../../../../Source/src/service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData } from  './../../../../Source/src/service/vzdl';

class subAccordion extends React.PureComponent {
    constructor(props) {
        super(props);
        this.subAccordionRef = React.createRef();
        this.openAccordTitle = '';
    }
    componentDidMount() {
        if(this.props.buildProduct?.perks?.isAddPerksOSI){
            if(this.subAccordionRef){
                accordionFocusAnimate(this.props.dispatch);
                focusAnimationPerks();
            }
        }
        if (this.props?.buildProduct?.isAPDataEnabled === true && this.props?.autopayDeclined) {
          this.handleChangeEvent(!this.props?.buildProduct?.isAPDataEnabled)
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props?.buildProduct?.isAPDataEnabled === true && this.props?.autopayDeclined && this.props?.autopayDeclined !== prevProps?.autopayDeclined) {
          this.handleChangeEvent(!this.props?.buildProduct?.isAPDataEnabled)
        }
        if (!this.props.buildProduct.focusParentAccordion && this.props.buildProduct.focusAccordion && this.props.isParentAccordionOpen && this.props.isAccordionOpen) {
            if (this.subAccordionRef) {
                if(this.props.buildProduct.router.isAccordionOpen && this.props.buildProduct.techsure.isAccordionOpen){
                    accordionFocusAnimate(this.props.dispatch);
                    focusAnimation(236);
                }
                else if(this.props.buildProduct.router.isAccordionOpen && this.props.buildProduct.mm3internetsub.isAccordionOpen){
                    accordionFocusAnimate(this.props.dispatch);
                    focusAnimation(236);
                }
                 else{
                    accordionFocusAnimate(this.props.dispatch);
                focusAnimation(this.subAccordionRef.offsetTop - (this.props.buildProduct.pendingProdNotification && this.props.buildProduct.pendingProdNotification.displaySpecificErrorMessages ? 50 : 0));
                }
                
            }
        }
        //Accessibility - when tabbing, focus on the next, open, sub-accordion title
        if (this.subAccordionRef && this.props.isParentAccordionOpen && this.props.isAccordionOpen && (this.openAccordTitle !== this.props.defaultTitle)) {
            this.openAccordTitle = this.props.defaultTitle;
            let bodyClass = document.querySelector('body').className;
            let redirectid = this.props.name;
            if (InHomeUtils.isNotNull(this.props.buildProduct.internet.selectedProduct)) {
                // if (this.props.buildProduct.router.accordionStatus !== "added") {
                //     redirectid = "toggle_internet_router_accor";
                // }
                redirectid = "toggle_internet_plan_accor";
            }
            if (!bodyClass || (bodyClass && bodyClass.indexOf('hide-focus-outline') === -1)) {
                let data = document.getElementById(redirectid);
                data?.getElementsByClassName('accord-acc-wrapper')?.[0]?.focus();
            }
        }
    }

    handleChangeEvent= (value) => {
        setAPEnabled(this.props.dispatch, value);
       
        setTimeout(()=>{
            updateSCTags(`Show pricing with auto pay & paper free billing discount- ${value}`)
           // updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
        },1000)
       
        // this.active = !this.active;
    }

    scrollToFccLabel =(element)=> {
        let getLabel = document.getElementById(element);
        getLabel.scrollIntoView({behavior: "smooth"})
        updateSCTags('broadband facts labels');
        
        let focusElem = document.getElementById("focus1");
        if(focusElem) {
            setTimeout(()=>{
                focusElem.focus()
            },1000)
        }
    }
    
    onLabelKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.scrollToFccLabel('Bf_Pagechkout'); 
        }
    }

    handleSpanishTab = ()=>{
        updateSCTags("Spanish")
        spanishTab(this.props.dispatch, true)
        tempVzdlSCData.detail = "Spanish";
        updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
    }
    
    handleClickSpanish = (e,index)=>{
        updateSCTags("Spanish")
        spanishTab(this.props?.dispatch, true, index);
        tempVzdlSCData.detail = "Spanish";
        updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
    }
    handleClickLiveTV = (e,index)=>{
        updateSCTags("Live TV")
        spanishTab(this.props?.dispatch, false, index);
        tempVzdlSCData.detail = "Add Live TV";
        updateVzdlSCCustomEvent("buildFiosInit","pageViewOmni","detail,events");
    }

    handleToolTip =()=>{
        updateSCTags('Show pricing with Auto Pay & paper-free billing discount')
    }

    render() {
        let title =   (this.props?.buildProduct?.isECMNEnabled) ? <AccordionTitleRskn titleOmniName={this.props.defaultTitle} title={this.props.defaultTitle} name={this.props.name} inputelementRef={this.props.inputelementRef}
            status={this.props.accordionStatus} isAccordionOpen={this.props.isAccordionOpen} isDoflow={this.props.isDoflow}></AccordionTitleRskn> : <AccordionTitle titleOmniName={this.props.defaultTitle} title={this.props.defaultTitle} name={this.props.name} inputelementRef={this.props.inputelementRef}
            status={this.props.accordionStatus} isAccordionOpen={this.props.isAccordionOpen} isDoflow={this.props.isDoflow}></AccordionTitle>;
        let products = "";
        let displayStyle = "";
        let channelList = "";
        let selectedProductTitle = "";
        let bbuship = "";
        let stb = '';
        let ceApps = '';
        let status = "added";
        let testDriveMsg = '';
        let nonNYDMALTODesc = "";
        let stadiaOfferVerbiage = this.props.stadiaOfferVerbiage || '';
        let marvelOfferVerbiage = this.props.marvelOfferVerbiage || '';
        let nydmaOfferVerbiage = this.props.nydmaOfferVerbiage || '';
        let subProduct = '';
        let tvLanguageTab = "";
        let toggleData = "";

        if (
            ((this.props?.buildProduct?.isECMNEnabled) && !(this.props.lqState.couponFlowType === "Employee" ||
                this.props.lqState.couponFlowType === "Retiree" || this.props.buildProduct?.isVZFwdFlag || this.props.buildProduct.isVZFCreditFlag) &&
            ((this.props?.buildProduct?.internet?.isSubAccordionOpen && 
            this.props.name === "toggle_internet_plan_accor") || (this.props?.buildProduct?.tv?.isAccordionOpen && this.props.name === "toggle_tv_plan_accor"))) || (!  (this.props?.buildProduct?.isECMNEnabled) && !this.props?.buildProduct?.internet?.mm3Qualified && this.props.name === "toggle_internet_plan_accor" && this.props?.buildProduct?.internet?.isSubAccordionOpen)
        ){
            const tooltipIconMobile = <span
            onMouseOver={this.handleToolTip}
          ><TrailingTooltip
            containerId='FiosHomeInternetAutoPayContainer'
            typographySize="large"
            typographyPrimitive= "span"
            ariaLabel=""
            tooltipSize="large"
            tooltipTitle="Auto Pay and Paper-Free Billing"
            tooltipContent={<div>
            <p style={{ fontSize: '11.75px' }}>
                When you enroll in Auto Pay and paper-free billing using your bank account or the Verizon Visa Card, you qualify for a $10/mo discount. Enrollment in Auto Pay and paper-free billing during checkout required for the discount.
            </p>
            {(this.props?.buildProduct?.tv?.isAccordionOpen && this.props.name === "toggle_tv_plan_accor") && (
                <p style={{ fontSize: '11.75px', color: '#6F7171' }}>
                    The YouTube TV plan doesn't qualify for this $10/mo discount.
                </p>
            )}
            </div>}
            onClick={this.handleToolTip}
            >
            </TrailingTooltip>
            </span>
            toggleData =
                <div id='' className="autopayPricing" >
                    <Toggle
                        value={this.props.buildProduct.isAPDataEnabled}
                        on={this.props.buildProduct.isAPDataEnabled}
                        surface="light"
                        surfaceType="colorFill"
                        showText={true}
                        textWeight="regular"
                        textSize="small"
                        textPosition="right"  
                        ariaLabel={'Show pricing with Auto Pay & paper-free billing discount'}                      
                        statusText={(e) => e ? <><span style={{ fontSize: '12px',fontFamily: "Verizon-NHG-eTX" }}>Show pricing with Auto Pay & paper-free billing discount</span> <span>{InHomeUtils.getdeviceType() === 'mobile' ? tooltipIconMobile: ''}</span></> : <><span style={{fontSize: '12px',fontFamily: "Verizon-NHG-eTX" }}>Show pricing with Auto Pay & paper-free billing discount</span> <span>{InHomeUtils.getdeviceType() === 'mobile' ? tooltipIconMobile: ''}</span></>}
                        onChange={(e) => this.handleChangeEvent(!this.props.buildProduct.isAPDataEnabled)}
                    />
                    {InHomeUtils.getdeviceType() !== 'mobile' ? <span style={{marginTop:'2px'}}>{tooltipIconMobile}</span>: ''}
                </div>
        }

        if (
            (  (this.props?.buildProduct?.isECMNEnabled) || !this.props.buildProduct.internet.mm3Qualified) &&
            this.props?.buildProduct?.tv?.isSubAccordionOpen && 
            this.props.name ==="toggle_tv_plan_accor"
        ) {
            let isSpanishTabHidden = true;
            if (this.props?.lqState?.isFCPflow === true && Array.isArray(this.props?.products)) {
                isSpanishTabHidden = this.props.products.every(item =>
                    (item?.prodType === "BASIC" || item?.prodType === "BASICDIFF")
                    && item?.prodTypeValue !== "LOCLDGTL"
                    && item?.prodTypeValue !== "MUNDO"
                    && item?.prodTypeValue !== "MUNDO_TOTAL"
                );
            }
            tvLanguageTab = (
                <>
                    {  (this.props?.buildProduct?.isECMNEnabled) ? toggleData : <></>}
                    <div className='languageTab'>
                        <Tabs
                            indicatorPosition="bottom"
                            orientation="horizontal"
                            linePosition="bottom"
                        >
                            <Tab
                            label="Live TV"
                            id="Live"
                            onClick={(e,index)=>this.handleClickLiveTV(e,index)}
                            onTabChange = {(e,index)=>this.handleClickLiveTV(e,index)}

                            selected={!this?.props?.buildProduct?.tv?.spanishTV}
                            />
                            <Tab
                            label="Spanish"
                            id="spanish"
                            // hide={isSpanishTabHidden}
                          //  onTabChange={()=>{ buildProductAction.spanishTab(this.props.dispatch, true)}}
                          onTabChange = {(e,index)=>this.handleClickSpanish(e,index)}
                            // onClick={(e, index) => {
                            //     buildProductAction?.spanishTab(this.props?.dispatch, true, index);
                            // }}
                            onClick ={(e,index)=>this.handleClickSpanish(e,index)}
                            selected={this?.props?.buildProduct?.tv?.spanishTV}
                            />
                        </Tabs>
                    </div>
                </>
            );
        }

        if (
              (this.props?.buildProduct?.isECMNEnabled) &&
            this.props?.buildProduct?.internet?.isSubAccordionOpen &&
            this.props.name === "toggle_internet_plan_accor"
           
        ){
            if(this.props?.buildProduct?.isMonarchView) {
                title = <div className="internetTitle">
                    <p style={{ marginBottom: 0, fontSize: '16px', fontFamily: "Verizon-NHG-eDS"}} className='internetSpeedSubaccordionTitle'>Internet speed</p>
                    <p style={{ color: '#6F7171', fontSize: '12px',fontFamily: "Verizon-NHG-eTX" }} className='chooseInternetSpeedOption'>Choose your internet speed option</p>
                </div>
            } else {
                title=
                <div className="internetTitle" >
                    <p style={{ color: '#6F7171', fontSize: '12px',fontFamily: "Verizon-NHG-eTX" }}  className='chooseInternetSpeedOption'>Choose your internet speed option</p>
                </div>
            }
        }
        
        if (InHomeUtils.isNotNull(this.props.selectedProduct) && (InHomeUtils.isNotEmpty(this.props.selectedProduct.id) || InHomeUtils.isNotEmpty(this.props.selectedProduct.prodId) || InHomeUtils.isNotEmpty(this.props.selectedProduct.unitCount) || InHomeUtils.isNotEmpty(this.props.selectedProduct.countryName))) {
            let isUnSupported = false;

            if (this.props.selectedProduct.prodType === Service.vas && InHomeUtils.isNotEmpty(this.props.selectedProduct.isProductSupported) && this.props.selectedProduct.isProductSupported === 'No') {
                isUnSupported = true;
            } else if (this.props.selectedProduct.prodTypeVal === 'PM-DVR') {
                isUnSupported = true;
            } else if (this.props.selectedProduct.prodType === Service.vRoom) {
                if (this.props.selectedProduct.quantity > 4) {
                    isUnSupported = true;
                } else if (this.props.selectedProduct.prodType === Service.vRoom && InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.tv) && InHomeUtils.isNotEmpty(this.props.buildProduct.tv.vcpestbQty) && this.props.buildProduct.tv.vcpestbQty > 4) {
                    isUnSupported = true;
                }
            }

            if (isUnSupported) {
                selectedProductTitle = this.props.defaultTitle;
            } else {
                if (this.props.selectedProduct.prodType === Service.winBack) {
                    if (this.props.selectedProduct.id === Service.winBackNo) {
                        selectedProductTitle = 'New Phone Number:'
                    }
                    else {
                        selectedProductTitle = 'Existing Phone Number:'
                    }
                    selectedProductTitle = selectedProductTitle + " " + this.props.requestTN;
                }
                else if (InHomeUtils.isNotEmpty(this.props.selectedProduct.prodType) && (this.props.selectedProduct.prodType === "SLABATTERY" || this.props.selectedProduct.prodType === "DCELLTRAY") && InHomeUtils.isNotNull(this.props.shipment) && InHomeUtils.isNotNull(this.props.shipment.selectedProduct) && InHomeUtils.isNotNull(this.props.selectedProduct.keyword) && this.props.selectedProduct.keyword.indexOf("BTRY_CHARGED") > 1) {
                    selectedProductTitle = 'Voice Backup PowerReserve + Shipping'
                }
                else if (InHomeUtils.isNotEmpty(this.props.selectedProduct.prodType) && (this.props.selectedProduct.prodType === "SLABATTERY" || this.props.selectedProduct.prodType === "DCELLTRAY") &&
                    InHomeUtils.isNotNull(this.props.selectedProduct.keyword) && this.props.selectedProduct.keyword.indexOf("ZRATED_DEC") > 1) {
                    selectedProductTitle = 'Voice Backup PowerReserve Declined'
                }
                else if (this.props.selectedProduct.prodType === 'ROUTERBILLER' && InHomeUtils.isNotEmpty(this.props.selectedProduct.name) && this.props.selectedProduct.name.indexOf('own') > -1) {
                    selectedProductTitle = InHomeUtils.isNotEmpty(this.props.customRouterName) ? ReactHtmlParser(this.props.customRouterName) : this.props.selectedProduct.name;
                }
                else if (this.props.selectedProduct.id === "NODCT") {
                    selectedProductTitle = 'No Free Digital Adapter'
                }
                //else if (InHomeUtils.isNotEmpty(this.props.selectedProduct.accordionTitle)) {
                //selectedProductTitle = ReactHtmlParser(this.props.selectedProduct.accordionTitle);
                //}
                else if (InHomeUtils.isNotNull(this.props.selectedProduct) && this.props.selectedProduct.prodType === "OTTEQUIPNRC" && InHomeUtils.isNotNull(this.props.streamingDevCnt.selectedProduct)) {
                    selectedProductTitle = this.props.streamingDevCnt.selectedProduct.name;
                }
                else if (this.props.intlCalling && InHomeUtils.isNotNull(this.props.selectedProduct)) {
                    selectedProductTitle = this.props.defaultTitle + " : " + this.props.selectedProduct.countryName;
                }
                else if (this.props.container && this.props.container === 'CEAPPS' && this.props.selectedProduct && this.props.selectedProduct.prodType && this.props.selectedProduct.prodType.includes(Service.vRoom)) {
                    selectedProductTitle = this.props.selectedProduct.accordionTitle ? this.props.selectedProduct.accordionTitle : this.props.selectedProduct.name || this.props.selectedProduct.prodName;
                }
                else if (this.props.container && (this.props.container === 'TVCONNECTIONS') && this.props.selectedProduct && this.props.selectedProduct.prodType && (this.props.selectedProduct.prodType.includes(Service.ceAppsParity) || this.props.selectedProduct.prodType.includes(Service.dummyvRoom))) {
                    let selectedstbProd = this.props.buildProduct.tvConnections && this.props.buildProduct.tvConnections.selectedProduct && (this.props.buildProduct.tvConnections.selectedProduct.prodId || this.props.buildProduct.tvConnections.selectedProduct.id) && this.props.buildProduct.tvConnections.equipments && this.props.buildProduct.tvConnections.equipments.filter(p => p && (p.id === this.props.buildProduct.tvConnections.selectedProduct.prodId || p.id === this.props.buildProduct.tvConnections.selectedProduct.id));
                    const vRoomCount = this.props.buildProduct.vRoom && this.props.buildProduct.vRoom.selectedProduct && this.props.buildProduct.vRoom.unitCount ? this.props.buildProduct.vRoom.unitCount : 0;
                    const stbCount = selectedstbProd && selectedstbProd.length && selectedstbProd[0].unitCount ? parseInt(selectedstbProd[0].unitCount) : 0;
                    const ceAppCount = this.props.buildProduct.ceApps.selectedProduct && this.props.buildProduct.ceApps.selectedProduct.prodType ? this.props.buildProduct.ceApps.selectedProduct.prodType === Service.ceAppsBundle ? 1000 : this.props.buildProduct.ceApps.selectedProduct.quantity ? parseInt(this.props.buildProduct.ceApps.selectedProduct.quantity) : 0 : 0;
                    selectedProductTitle = `${stbCount ? ` ${stbCount} Set-top box${stbCount > 1 ? 'es' : ''}` : ''} ${vRoomCount !== stbCount ? `${stbCount && ceAppCount ? ' + ' : ''} ${ceAppCount ? ceAppCount === 1000 ? ' Streaming Device Connection Bundle' : ` ${ceAppCount} streaming device${ceAppCount > 1 ? 's' : ''}` : ''}` : ''}`;
                }
                else {
                    if (InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.streamServ)
                        && InHomeUtils.isNotNull(this.props.buildProduct.streamServ.selectedProduct) && this.props.buildProduct.streamServ.selectedProduct.prodType === "OTTBASIC"
                        && this.props.buildProduct.streamServ.selectedProduct.prodTypeValue === Service.slingtv && this.props.selectedProduct === null) {
                        selectedProductTitle = this.props.buildProduct.streamServ.selectedProduct.name;
                    }
                    if (InHomeUtils.isNotNull(this.props.buildProduct) && InHomeUtils.isNotNull(this.props.buildProduct.streamServ)
                        && InHomeUtils.isNotNull(this.props.buildProduct.streamServ.selectedProduct) && this.props.buildProduct.streamServ.selectedProduct.prodType === "OTTBASIC"
                        && this.props.buildProduct.streamServ.selectedProduct.prodTypeValue === Service.slingtv && this.props.selectedProduct != null &&
                        (this.props.selectedProduct.prodType === "BASIC" || this.props.selectedProduct.prodType === "BASICDIFF" || this.props.selectedProduct.prodType === "OTTBASIC")) {
                        if (this.props.selectedProduct.name) {
                            selectedProductTitle = (this.props.selectedProduct.name || this.props.buildProduct.streamServ.selectedProduct.prodName) + " + " + (this.props.buildProduct.streamServ.selectedProduct.name || this.props.buildProduct.streamServ.selectedProduct.prodName);
                        }
                        else if (this.props.buildProduct.streamServ.selectedProduct.prodName) {
                            selectedProductTitle = this.props.buildProduct.streamServ.selectedProduct.prodName;
                        }
                    }
                    else {
                        selectedProductTitle = this.props.selectedProduct.name || this.props.selectedProduct.prodName;
                    }
                }
            }
            if (this.props.selectedProduct && this.props.selectedProduct.speedCode === "947") {
                selectedProductTitle = "2 Gig";
            }
            status = (InHomeUtils.isNotEmpty(this.props.selectedProduct.keyword) && ((this.props.selectedProduct.keyword.indexOf("CHARGED") > -1 && this.props.isShipmentAvailable) || this.props.selectedProduct.keyword.indexOf("SHIPMENT") > -1)) ? this.props.accordionStatus : "added";

            if (status === 'added' && this.props.selectedProduct.prodTypeVal && this.props.selectedProduct.prodTypeVal === "Fios_Five" && this.props.buildProduct.tv.fiosFiveSelectedChannels && !this.props.buildProduct.tv.fiosFiveSelectedChannels.length) {
                status = 'required';
            }
            selectedProductTitle = typeof selectedProductTitle === "string" ? ReactHtmlParser(selectedProductTitle) : selectedProductTitle;
            if (this.props.container && (this.props.container === 'CEAPPS' || this.props.container === 'TVCONNECTIONS')) {
                status = this.props.accordionStatus;
            }
            title = (this.props?.buildProduct?.isECMNEnabled) ? <AccordionTitleRskn locationId={this.props.locationId} titleOmniName={this.props.defaultTitle} isHidePromo={this.props.isHidePromo} title={selectedProductTitle} inputelementRef={this.props.inputelementRef} name={this.props.name} status={status} isAccordionOpen={this.props.isAccordionOpen} isDoflow={this.props.isDoflow}></AccordionTitleRskn> : <AccordionTitle locationId={this.props.locationId} titleOmniName={this.props.defaultTitle} isHidePromo={this.props.isHidePromo} title={selectedProductTitle} inputelementRef={this.props.inputelementRef} name={this.props.name} status={status} isAccordionOpen={this.props.isAccordionOpen} isDoflow={this.props.isDoflow}></AccordionTitle>;
        }
        else if (!this.props.intlCalling && InHomeUtils.isNotNull(this.props.selectedProduct) && InHomeUtils.isNotNull(this.props.selectedProduct.length) && this.props.selectedProduct.length > 0) {
            let channelsSupported = [];
            this.props.selectedProduct.forEach(prod => {
                if (prod.prodId !== "7486943" && InHomeUtils.isNull(prod.isVCloudProd) && (InHomeUtils.isNull(prod.isProductSupported) || (prod.isProductSupported && prod.isProductSupported.toUpperCase() === 'Y')) || (InHomeUtils.isNotNull(prod.prodName) && prod.prodName.indexOf("Inside Wire") > -1) || (InHomeUtils.isNotNull(prod.prodName) && prod.prodName.indexOf("Verizon Home") > -1)) {
                    channelsSupported.push(prod);
                }
                if (prod.prodId === "7486943") {
                    channelsSupported.unshift(prod);
                }
                if (prod.isVCloudProd && prod.isVCloudProd === "Yes") {
                    channelsSupported.unshift(prod);
                }
            })
            if (channelsSupported.length > 0) {
                selectedProductTitle = channelsSupported.map(p => p.prodType === Service.internationalPackage && p.accordionTitle ? ReactHtmlParser(p.accordionTitle) : ReactHtmlParser(p.prodName)).toString().replace(/,/gi, ' + ');
            } else {
                selectedProductTitle = this.props.defaultTitle;
            }
            title = this.props.buildProduct?.isECMNEnabled ? <AccordionTitleRskn locationId='' isHidePromo='true' titleOmniName={this.props.defaultTitle} title={selectedProductTitle} inputelementRef={this.props.inputelementRef} name={this.props.name} status="added" isAccordionOpen={this.props.isAccordionOpen} isDoflow={this.props.isDoflow}></AccordionTitleRskn> : <AccordionTitle locationId='' isHidePromo='true' titleOmniName={this.props.defaultTitle} title={selectedProductTitle} inputelementRef={this.props.inputelementRef} name={this.props.name} status="added" isAccordionOpen={this.props.isAccordionOpen} isDoflow={this.props.isDoflow}></AccordionTitle>;
            channelList = this.props.selectedProduct.map(p => p.prodId).toString();
        }

        if (this.props.isAccordionOpen) {
            if (channelList === "") {
                products = <ProductContainer cart={this.props.cart} notification={this.props.notification} flowType={this.props.flowType} products={this.props.products} style={{ displayStyle }} localChannelMsg={this.props.localChannelMsg}
                    selectedProduct={InHomeUtils.isNotNull(this.props.selectedProduct) && this.props.selectedProduct.id !== '' ? this.props.selectedProduct : ""}
                    voiceTN={InHomeUtils.isNotNull(this.props.requestTN) && this.props.requestTN !== '' ? this.props.requestTN : ''} openModel={this.props.openModel} modalWindow={this.props.modalWindow} toggle={this.props.toggle} showMoreClick={this.props.showMoreClick} speedCode={this.props.speedCode}
                    visitId={this.props.visitId} visitorId={this.props.visitorId} buildProduct={this.props.buildProduct} lqState={this.props.lqState} firstBill={this.props.firstBill} dispatch={this.props.dispatch} toggleTVMoreOption={this.props.toggleTVMoreOption} showMoreTvOption={this.props.showMoreTvOption} intlCalling={this.props.intlCalling} intlCallingProducts={this.props.intlCallingProducts}
                    emergServ={this.props.emergServ} emergencyServicesEmail={this.props.emergencyServicesEmail} emergencyServicesMobile={this.props.emergencyServicesMobile}
                    recommendedTV={this.props.recommendedTV} suppSelectedProds={this.props.suppSelectedProds} stadiaOfferVerbiage={stadiaOfferVerbiage} marvelOfferVerbiage={marvelOfferVerbiage} nydmaOfferVerbiage={nydmaOfferVerbiage} appState={this.props.appState} suppHasSlingTV={this.props.suppHasSlingTV} container={this.props.container} supphasPreholidayGC={this.props.supphasPreholidayGC}
                    supphashasBlackFriday={this.props.supphashasBlackFriday} 
                    toggleRouterMoreOption={this.props.toggleRouterMoreOption} showMoreRouterOption={this.props.showMoreRouterOption}/>;
            }
            else {
                products = <ProductContainer notification={this.props.notification} flowType={this.props.flowType} products={this.props.products} style={{ displayStyle }}
                    selectedChannels={channelList}
                    selectedProduct={channelList}
                    voiceTN={this.props.requestTN !== undefined && this.props.requestTN !== null && this.props.requestTN !== '' ? this.props.requestTN : ''} openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                    visitId={this.props.visitId} visitorId={this.props.visitorId} buildProduct={this.props.buildProduct} lqState={this.props.lqState} firstBill={this.props.firstBill} dispatch={this.props.dispatch}
                    recommendedTV={this.props.recommendedTV} suppSelectedProds={this.props.suppSelectedProds} stadiaOfferVerbiage={stadiaOfferVerbiage} marvelOfferVerbiage={marvelOfferVerbiage} nydmaOfferVerbiage={nydmaOfferVerbiage} appState={this.props.appState} container={this.props.container} />;
            }

            if (InHomeUtils.isNotNull(this.props.selectedProduct) && InHomeUtils.isNotNull(this.props.selectedProduct.keyword) && this.props.selectedProduct.keyword.indexOf("CHARGED") > -1 && this.props.isShipmentAvailable) {
                bbuship = <ProductContainer notification={this.props.notification} flowType={this.props.flowType} products={this.props.shipment.shipmentProducts} style={{ displayStyle }}
                    selectedProduct={InHomeUtils.isNotNull(this.props.shipment.selectedProduct) && this.props.shipment.selectedProduct.id !== '' ? this.props.shipment.selectedProduct : ""}
                    voiceTN={InHomeUtils.isNotNull(this.props.requestTN) && this.props.requestTN !== '' ? this.props.requestTN : ''} openModel={this.props.openModel} modalWindow={this.props.modalWindow} toggle={this.props.toggle} showMoreClick={this.props.showMoreClick}
                    visitId={this.props.visitId} visitorId={this.props.visitorId} buildProduct={this.props.buildProduct} lqState={this.props.lqState} firstBill={this.props.firstBill} dispatch={this.props.dispatch} toggleTVMoreOption={this.props.toggleTVMoreOption} showMoreTvOption={this.props.showMoreTvOption} suppSelectedProds={this.props.suppSelectedProds} container={this.props.container} />;
            }

            if (InHomeUtils.isNotNull(this.props.streamingDevCnt) && InHomeUtils.isNotNull(this.props.selectedProduct)) {
                subProduct = <ProductContainer notification={this.props.notification} flowType={this.props.flowType} products={this.props.streamingDevCnt.streamDevCountProd} style='true'
                    selectedChannels={channelList}
                    selectedProduct={this.props.streamingDevCnt.selectedProduct}
                    voiceTN={this.props.requestTN !== undefined && this.props.requestTN !== null && this.props.requestTN !== '' ? this.props.requestTN : ''} openModel={this.props.openModel} modalWindow={this.props.modalWindow}
                    visitId={this.props.visitId} visitorId={this.props.visitorId} buildProduct={this.props.buildProduct} lqState={this.props.lqState} firstBill={this.props.firstBill} dispatch={this.props.dispatch} suppSelectedProds={this.props.suppSelectedProds} container={this.props.container} />;
            }
            
            if (this.props.ceApps) {
                ceApps = <ProductContainer notification={this.props.notification} flowType={this.props.flowType} products={this.props.ceApps.displaySection} style={{ displayStyle }}
                    selectedProduct={InHomeUtils.isNotNull(this.props.ceApps.selectedProduct) && this.props.ceApps.selectedProduct.id !== '' ? this.props.ceApps.selectedProduct : ""}
                    voiceTN={InHomeUtils.isNotNull(this.props.requestTN) && this.props.requestTN !== '' ? this.props.requestTN : ''} openModel={this.props.openModel} modalWindow={this.props.modalWindow} toggle={this.props.toggle} showMoreClick={this.props.showMoreClick}
                    visitId={this.props.visitId} visitorId={this.props.visitorId} buildProduct={this.props.buildProduct} lqState={this.props.lqState} firstBill={this.props.firstBill} dispatch={this.props.dispatch} toggleTVMoreOption={this.props.toggleTVMoreOption} showMoreTvOption={this.props.showMoreTvOption} suppSelectedProds={this.props.suppSelectedProds} container={this.props.container} />;
            }
            testDriveMsg = this.props.testDriveMsg;
        }

        if(this.props.isAccordionOpen && this.props.products && this.props.products.length > 0 && this.props.products.filter(x=>x.prodType == "FTTPD" && x.productKeyword && x.productKeyword.indexOf("LTO") != -1).length > 0){
            nonNYDMALTODesc = <p className="nonNYDMALTO">For a limited time, get even more speed at no extra cost.</p>
        }

        if (!this.props.isParentAccordionOpen) { 
            displayStyle = true;
        }

        const mnRouter = this.props?.buildProduct?.isMNEnabled && (this.props?.defaultTitle === 'Internet equipment' || this.props?.name === 'toggle_internet_perks_accor') && this.props?.buildProduct?.internet?.selectedProduct === null;
        const mnPerksClassic = !this.props?.buildProduct?.mnFromApi && !this.props?.buildProduct?.internet?.mm3Qualified && this.props?.name === 'toggle_internet_perks_accor' && (this.props?.buildProduct?.internet?.selectedProduct === null || (this.props?.buildProduct?.tv?.selectedProduct === null && this.props?.buildProduct?.voice?.selectedProduct === null) || (this.props?.buildProduct?.tv?.selectedProduct?.prodTypeValue?.toUpperCase?.() === "YOUTUBE" && this.props?.buildProduct?.voice?.selectedProduct === null) || (this.props?.buildProduct?.tv?.selectedProduct !== null && !this.props?.buildProduct?.isenableCheckout));

        return (
            <div className={`row accordion_blocks-content ${(this.props?.buildProduct?.isECMNEnabled) ? '' : 'margin-vert-large border-left border-right border-bottom bg-white-active'}`} style={{ transition: 'opacity 300ms', display: displayStyle ? 'none' : '' }} ref={(el) => this.subAccordionRef = el}>
                <div className="row padding-all-zero margin-all-zero">
                    <div className="columns padding-all-zero">
                        <div className="w_accordion" data-cs-mask={this.props.datacsmask}>
                            <div className={(mnRouter || mnPerksClassic || (this.props?.flowType === "SUPP" && InHomeUtils.isNotNull(this.props?.vasProduct) && this.props?.vasProduct && InHomeUtils.isNotNull(this.props?.suppHasVas) && this.props?.suppHasVas)) ? "accordion_blocks padding-top-zero disabled" : "accordion_blocks padding-top-zero"}>
                                {title}
                                {this.props.name === "toggle_internet_plan_accor" ? toggleData : <></>}
                                {testDriveMsg}
                                {nonNYDMALTODesc}
                                {stb}
                                {(this.props?.buildProduct?.isECMNEnabled) && tvLanguageTab}
                                {products}
                                {
                                    this.props.name === "toggle_internet_plan_accor" && this.props.isAccordionOpen ?
                                    <>
                                    {
                                        this.props.buildProduct.fccLabelInfo && this.props.buildProduct.fccLabelInfo.length > 0 && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey?.ShowFccLabelInfo === 'Y' && 
                                        <div style={this.props.lqState.isFCPflow?{marginTop: '10px',marginLeft: '30px'}:{marginTop: '10px', marginLeft: '30px'}}>
                                            <p class="mm3-text-large" className='jumpToBroadband'>
                                                <span style={{ fontSize: '14px' }} className="margin-right-micro">Jump to</span>
                                                <a className="text-black mm3-text-small" onClick={()=>this.scrollToFccLabel('toggle_fcc_id')} 
                                                 onKeyDown={this.onLabelKeyDown}
                                                 tabIndex="0"  role='button' aria-label='Jump to the Broadband facts label'>Broadband Facts Labels</a>
                                            </p>
                                        </div>
                                    }
                                    {this.props.children && (
                                        <div className="subAccordionRskn_children" style={{... (InHomeUtils.getdeviceType() === 'mobile' ? {padding: "0px 0px"} : {paddingLeft: "65px", width: "100%", paddingRight: '65px'}) }}>
                                            {this.props.children}
                                        </div>
                                    )}
                                    </> : <></>
                                }
                                {ceApps}
                                {subProduct}
                                {bbuship}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        visitId: state.app.visitId,
        visitorId: state.app.visitorId,
        buildProduct: state.buildProduct,
        lqState: state.loopQual,
        firstBill: state.firstbill,
        recommendedTV: state.customTvRecommendation.recommendedTV,
        autopayDeclined: state?.profileCart?.cartData?.[0]?.Promotions?.promotions?.find(p => p?.offerAttrValue === "FCP_AUTOPAY_DECLINE") || state?.ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.find(p => p?.offerAttrValue === "FCP_AUTOPAY_DECLINE") ? true : false,
        suppSelectedProds: state.supp.suppSelectedProds
    }
}
export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(subAccordion);
